<template>
    <!-- <div class="cb-navbar"> -->
    <div class="header" id="headers">
        <div class="header_son">
            <img src="@/assets/images/logo2.png" alt="24Hours" class="Hours" @click="skipIndex"/>
            <div class="headers_right">
                <wallet-connect></wallet-connect>
                <div class="ph_rbox_selects" @click="drawer = true">
                    <img src="@/assets/images/more2.png" alt="more" class="more"/>
                </div>
                <!-- <div class="ph_rbox_select">
                    <img v-if="valueTwo=='BNB'" src="@/assets/images/BNB.png" alt="BNB" class="tokenImg"/>
                </div> -->
                <!-- <div class="ph_rbox_selects" @click="changeLanguage(nowLang)">
                    <img v-if="valueTwo=='BNB'&&nowLang == 'zh_CN'" src="@/assets/images/zh_CN.png" alt="BNB" class="tokenImg"/>
                    <img v-if="valueTwo=='BNB'&&nowLang == 'en_US'" src="@/assets/images/en_US.png" alt="BNB" class="tokenImg"/>
                </div> -->
            </div>
        </div>
        <el-drawer
          title=""
          :visible.sync="drawer"
          :direction="direction"
          :append-to-body="judges"
          size="60%"
          :show-close='showClose'>
          <span>
              <!-- <div class="logoLOff">
                <img src="@/assets/images/logo2.png" alt="logo" class="logoL"/>
                <img src="@/assets/images/Off1.png" alt="Off" class="Off" @click="drawer=false" />
              </div>
              <div class="drawer_title" @click="handleClick('About')">
                  <span>{{$t('value48')}}</span>
              </div>
              <div class="drawer_title" @click="handleClick('TokenEconomic')">
                  <span>{{$t('value49')}}</span>
              </div>
              <div class="drawer_title" @click="handleClick('Governance')">
                  <span>{{$t('value50')}}</span>
              </div>
              <div class="drawer_title" @click="handleClick('Launchpad')">
                  <span>{{$t('value51')}}</span>
              </div>
              <div class="sidebar_two_title">
                  <div @click="ClickTwo()" style="cursor: pointer;display: flex;flex-direction: row;align-items: flex-end;">
                    <span class="Introduction">{{this.$t('value46')}}</span>
                    <img src="@/assets/images/img26.png" alt="img26" class="img26" />
                  </div>
                  <div class="sidebar_two_downContent"  v-show="judgeTwo1">
                      <div @click="changeLanguage('zh_CN')">English</div>
                      <div @click="changeLanguage('en_US')">中文</div>
                  </div>
              </div> -->
              <!-- //kai -->
              <div class="sidebar_two_ch">
                  <div class="animate__animated animate__fadeIn animate__slow sidebar_two_ch_one">
                      <div class="logoLOff">
                        <img src="@/assets/images/logo2.png" alt="logo" class="logoL" @click="skipIndex"/>
                        <img src="@/assets/images/Off1.png" alt="Off" class="Off" @click="drawer=false" />
                      </div>
                      <div>
                          <div class="drawer_title" @click="judgeTwo=!judgeTwo" style="flex-direction: column;align-items: flex-start;">
                            <div style="display: flex;align-items: center;">
                              <img src="@/assets/images/2.png" alt="RDOM" class="RDOM"> 
                              <div style="display: flex;align-items: center;">
                                <span>{{$t('value71')}}</span>
                                <img src="@/assets/images/img26.png" alt="img26" class="img26" />
                              </div>
                            </div>
                            <div class="sidebar_two_downContent"  v-show="judgeTwo">
                                <div class="drawer_titles drawer_titlesa" @click="handleClick('About')">
                                    <span>{{$t('value48')}}</span>
                                </div>
                                <div class="drawer_titles" @click="handleClick('TokenEconomic')">
                                    <span>{{$t('value49')}}</span>
                                </div>
                                <div class="drawer_titles" @click="handleClick('Governance')">
                                    <span>{{$t('value50')}}</span>
                                </div>
                                <div class="drawer_titles" style="margin-bottom: 0px;" @click="handleClick('Launchpad')">
                                    <span>{{$t('value51')}}</span>
                                </div>
                            </div>
                          </div>
                      </div>
                      <div>
                          <!-- <router-link class="drawer_title" to="/TreasureBowl">
                              <img src="@/assets/images/3.png" alt="NFT" class="NFT">
                              <span id="IntroductionFour">{{$t('value81')}}</span>
                          </router-link> -->
                          <div class="drawer_title" @click="NotLoggedIn('/TreasureBowl')">
                              <img src="@/assets/images/3.png" alt="NFT" class="NFT">
                              <span id="IntroductionFour">{{$t('value81')}}</span>
                          </div>
                      </div>
                      <div>
                          <!-- <router-link class="drawer_title" to="/NFTPledge">
                              <img src="@/assets/images/3.png" alt="NFT" class="NFT">
                              <span id="IntroductionFour">{{$t('value72')}}</span>
                          </router-link> -->
                          <div class="drawer_title" @click="NotLoggedIn('/NFTPledge')"> 
                              <img src="@/assets/images/3.png" alt="NFT" class="NFT">
                              <span id="IntroductionFour">{{$t('value72')}}</span>
                          </div>
                      </div>
                      <div>
                          <!-- <router-link class="drawer_title" to="/TokenStaking">
                              <img src="@/assets/images/4.png" alt="Airdrop" class="Airdrop">
                              <span id="IntroductionFive">{{$t('value73')}}</span>
                          </router-link> -->
                          <div class="drawer_title" @click="NotLoggedIn('/TokenStaking')">
                              <img src="@/assets/images/4.png" alt="Airdrop" class="Airdrop">
                              <span id="IntroductionFive">{{$t('value73')}}</span>
                          </div>
                          
                      </div>
                      <div>
                          <!-- <router-link class="drawer_title" to="/LPStaking">
                              <img src="@/assets/images/5.png" alt="Airdrop" class="ifBank">
                              <span class="IntroductionFive" id="IntroductionFive">{{$t('value74')}}</span>
                          </router-link> -->
                           <div class="drawer_title" @click="NotLoggedIn('/LPStaking')">
                              <img src="@/assets/images/5.png" alt="Airdrop" class="ifBank">
                              <span class="IntroductionFive" id="IntroductionFive">{{$t('value74')}}</span>
                          </div>
                      </div>
                      <div>
                          <!-- <router-link class="drawer_title" to="/CommissionDividend">
                              <img src="@/assets/images/7.png" alt="Airdrop" class="ifBank">
                              <span class="IntroductionFive" id="IntroductionFive">{{$t('value75')}}</span>
                          </router-link> -->
                          <div class="drawer_title" @click="NotLoggedIn('/CommissionDividend')">
                              <img src="@/assets/images/7.png" alt="Airdrop" class="ifBank">
                              <span class="IntroductionFive" id="IntroductionFive">{{$t('value75')}}</span>
                          </div>
                      </div>
                      <div>
                          <!-- <router-link class="drawer_title" to="/CommunityInvitation">
                              <img src="@/assets/images/8.png" alt="Airdrop" class="ifBank">
                              <span class="IntroductionFive" id="IntroductionFive">{{$t('value76')}}</span>
                          </router-link> -->
                          <div class="drawer_title" @click="NotLoggedIn('/CommunityInvitation')">
                              <img src="@/assets/images/8.png" alt="Airdrop" class="ifBank">
                              <span class="IntroductionFive" id="IntroductionFive">{{$t('value76')}}</span>
                          </div>
                            
                      </div>
                      <div class="sidebar_two_title">
                          <div @click="ClickTwo()" style="cursor: pointer;display: flex;flex-direction: row;align-items: center;">
                            <img src="@/assets/images/6.png" alt="Airdrop" class="ifBank">
                            <div style="display: flex;align-items: center;">
                                <span class="Introduction">{{this.$t('value46')}}</span>
                                <img src="@/assets/images/img26.png" alt="img26" class="img26" />
                            </div>
                          </div>
                          <div class="sidebar_two_downContent"  v-show="judgeTwo1">
                              <div @click="changeLanguage('zh_CN')">English</div>
                              <div @click="changeLanguage('en_US')">中文</div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- <div class="sidebar_two_ch">
                  <div class="animate__animated animate__fadeIn animate__slow sidebar_two_ch_one">
                      <div>
                          <router-link to="/">
                              <img src="@/assets/images/2.png" alt="home" class="home">
                              <span class="IntroductionOne Introductions" id="IntroductionOne">{{this.$t('Home')}}</span>
                          </router-link>
                      </div>
                      <div>
                          <img src="@/assets/images/3.png" alt="RDOM" class="RDOM"> 
                          <span class="IntroductionTwo" id="IntroductionTwo" @click="judgeTwo=!judgeTwo">{{this.$t('DollarAavingsContract')}}</span>
                          <div class="sidebar_two_downContent"  v-show="judgeTwo">
                              <router-link :to="{path:'/MetaSavingsAgreement', query: {calssJuged:'1'}}">
                                  <div @click="drawer=false">{{this.$t('DemandDeposit')}}</div>
                              </router-link>
                              <router-link :to="{path:'/MetaSavingsAgreement', query: {calssJuged:'2'}}">
                                  <div @click="drawer=false">{{this.$t('TimeDeposit')}}</div>
                              </router-link>
                          </div>
                      </div>
                      <div>
                          <div @click="NotYetOpen">
                              <img src="@/assets/images/4.png" alt="NFT" class="NFT">
                              <span class="IntroductionFour" id="IntroductionFour">{{this.$t('MetaTransactionContract')}}</span>
                          </div>
                      </div>
                      <div>
                          <router-link to="/inviteTeamLeader">
                              <img src="@/assets/images/5.png" alt="Airdrop" class="Airdrop">
                              <span class="IntroductionFive" id="IntroductionFive">{{this.$t('UserDataContract')}}</span>
                          </router-link>
                      </div>
                      <div>
                          <router-link to="/Recharge">
                              <img src="@/assets/images/if-bank.png" alt="Airdrop" class="ifBank">
                              <span class="IntroductionFive" id="IntroductionFive">{{this.$t('CentralBank')}}</span>
                          </router-link>
                      </div>
                      <div>
                          <img src="@/assets/images/multilingual.png" alt="languageSwitch" class="languageSwitch">
                          <span class="Introduction" @click="ClickTwo()">{{this.$t('language')}}</span>
                          <div class="sidebar_two_downContent"  v-show="judgeTwo1">
                              <div @click="language('en')">English</div>
                              <div @click="language('zh')">中文</div>
                          </div>
                      </div>
                  </div>
              </div> -->
              <div class="Download">
                  <!-- <div class="Download_title">— Download —</div>
                  <div class="Wallets">Wallets</div> -->
                  <div class="Wallets_img">
                      <img src="@/assets/images/Twitter1.png" alt="Twitter" class="Twitter"  @click="imgClick('Twitter')"/>
                      <img src="@/assets/images/telegram1.png" alt="telegram" class="telegram"  @click="imgClick('telegram')"/>
                      <img src="@/assets/images/Medium1.png" alt="Medium" class="Medium"  @click="imgClick('Medium')"/>
                      <img src="@/assets/images/github1.png" alt="github" class="github"  @click="imgClick('github')"/>
                      <div class="Wallets_div"></div>
                      <div class="Wallets_div"></div>
                      <div class="Wallets_div"></div>
                      <div class="Wallets_div"></div>
                  </div>
                  <!-- <div class="Exchanges">Exchanges</div>
                  <div class="Exchanges_img">
                      <img src="@/assets/images/Krakenlogo.png" alt="Krakenlogo" @click="imgClick('Krakenlogo')">
                      <img src="@/assets/images/binance.png" alt="binance" @click="imgClick('binance')">
                      <img src="@/assets/images/OKEX.png" alt="OKEX" @click="imgClick('OKEX')">
                  </div> -->
                </div>
            </span>
          </el-drawer>

    </div>
</template>

<script>
import WalletConnect from '@/components/wallet-connect/index.vue'
// import router from '@/router';
// import { addEventListeners } from '@/web3/index'
import { JudgeTheConnectionWallet } from '@/web3/index'
// import { mapState, mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
export default {
    name: 'CBNavbar',
    components: {
        WalletConnect
    },
    data() {
        return {
          judge: false,
          myAccountAddr: '',
          judgeTwo: false,
          judgeTwo1: false,
          nowLang: '',
          drawer: false,
          direction: 'rtl',
          judges: true,
          showClose: false,
          wide: '57%',
          optionsTwo: [
              { value: 'BNB', label: 'BNB' },
              { value: 'polygon', label: 'polygon' },
              { value: 'TRX', label: 'TRX' },
              { value: 'ARB', label: 'ARB' }
          ],
          optionsTLan: [
              { value: '中文', label: '中文' },
              { value: 'English', label: 'English' }
          ],
          valueTwo: 'BNB',
          valueTwo1: '中文',
          value1: '中文',
          valueTwos: '',
          value: 'BNB',
        };
    },
    computed: {
        walletAddress() {
            return this.$store.state.address;
        }
    },
    watch: {
        walletAddress() {
          // this.$store.commit('setAddress', newAddress);
          console.log('在这里可以执行其他操作222');
          this.$store.dispatch('logout').then();
          // 在这里可以执行其他操作
        }
    },
    methods: {
      comingSoon(){
        console.log('点击了');
        
        this.$message(this.$t('comingSoon'))
      },
      NotLoggedIn(value){
        // if(value!=='/TreasureBowl'){
        //   this.comingSoon()
        //   return
        // }
        if(value!=='/TreasureBowl'&&value!=="/CommissionDividend"&&value!=="/NFTPledge"){
          this.comingSoon()
          return
        }
        const token = getToken();
        if (!token) {
          this.$message(this.$t('value123'))
        }else{
          this.$router.push(value)
        }
      },
      imgClick(value){
        switch (value) {
          case "Twitter":
            window.location.href="https://x.com/metaflowlabs?s=11&t=TdwcgclQrTygwiCleIZO9w"
            break;
          case "telegram":
            window.location.href="https://t.me/+-3XFpuGFBsowNmJl"
            break;
          case "Medium":
            window.location.href="https://medium.com/@Metaflow.network"
            break;
          case "github":
            
            break;
          default:
            break;
        }
      },
      ClickTwo(){
        console.log('点击');
        
        this.judgeTwo1=!this.judgeTwo1
      },
      handleClick(value) {
        this.$emit('navbar-click', value)
      },
      skipIndex(){
        this.$router.push('/')
      }, 
      changeLanguage(lang) {
        lang=='en_US'?this.nowLang='zh_CN':this.nowLang='en_US' 
        this.$i18n.locale = this.nowLang; // 切换语言
        localStorage.setItem('language', this.nowLang); // 保存到本地存储
        this.$store.state.lang=this.nowLang
      }, 
      isPC() {
          const userAgent = navigator.userAgent;
          const isPC = !/Android|iPhone|iPad|iPod|IEMobile|Opera Mini/.test(userAgent);
          
          return isPC;
      }
    },
    created() {
      let nowLang = localStorage.getItem('language') || 'en_US';
      this.nowLang=nowLang
      this.$i18n.locale = nowLang; // 初始化语言
    },
    mounted() {
      if (window.ethereum!==undefined) {
          // const address = this.$store.state.address;
           // 从 sessionStorage 获取标志
          // if (!this.isPC()&&address !== window.ethereum.selectedAddress) {
          //   this.$store.commit('setAddress', window.ethereum.selectedAddress);
          //   this.$store.dispatch('logout').then(() => {
          //       location.href = process.env.VUE_APP_CONTEXT_PATH + 'index';
          //   });
          //     // 设置标志为已执行并存储到 sessionStorage
          // }
          setInterval(()=>{
            //  alert('按时大大')
            // addEventListeners(this)
            JudgeTheConnectionWallet(this)
          },1000)
        }
    },
    // beforeRouteEnter(to, from, next) {
    //     const address = this.$store.state.address;
    //     if (!this.isPC() && address !== window.ethereum.selectedAddress) {
    //         this.$store.commit('setAddress', window.ethereum.selectedAddress);
    //         this.$store.dispatch('logout').then(() => {
    //             next({ path: process.env.VUE_APP_CONTEXT_PATH + 'index' });
    //         });
    //     } else {
    //         next();
    //     }
    // },
}
</script>
<style lang="less" scoped>

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background: #000;
  .header_son {
    width: 92%;
    margin: auto;
    height: 112px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .Hours {
    // width: 228px;
    height: 80px;
  }
  
  .headers_right {
    display: flex;
    align-items: center;
    
    .wallet {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 63px;
      margin-right: 31px;
      text-align: center;
      width: 253px;
      height: 63px;
      background: #000000;
      border-radius: 32px;
      border: 2px solid #937B46;
      
      .EntryArrow {
        display: flex;
        width: 13px;
        margin-left: 15px;
        height: 20px;
      }
    }
    
    .wallets {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 63px;
      margin-right: 31px;
      text-align: center;
      width: 247px;
      height: 61px;
      border-radius: 29px;
      background: #000;
      border: 2px solid #937B46;
      font-size: 25px;
      .EntryArrow {
        display: flex;
        width: 13px;
        margin-left: 15px;
        height: 20px;
      }
    }
  }
  
  .MenuPictures {
    display: inline-block;
    z-index: 10;
    width: 1.38892rem;
    height: 1.16667rem;
  }
}

.el-input__inner {
  text-indent: 1.5em;
  color: #fff;
}

.el-select,
.el-select > .el-input {
  height: 100%;
  position: absolute;
  left: 0;
}

.el-select .el-input__inner {
  border-radius: 1.25rem;
  height: 100%;
  border: 0.125rem solid #f7b10a;
}

.el-select .el-input .el-select__caret {
  display: flex;
  align-items: center;
}

.el-input__inner {
  border: 0rem solid #f7b10a !important;
}

.el-input__suffix {
  display: none;
}

.ph_rbox_select {
  width: 45px;
  margin: 0 25px 0 0;
  border-radius: 1.25rem;
  height: 45px;
  position: relative;
  display: flex;
  align-items: center;

  .el-select {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
  }
}
.ph_rbox_selects{
  width: 45px;
  margin: 0 0 0 0;
  border-radius: 1.25rem;
  height: 45px;
  position: relative;
  display: flex;
  align-items: center;

  .el-select {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
  }
  .tokenImg{
    width: 45px;
    height: 45px;
  }
  .more{
    width: 37px;
    height: 37px;
  }
}
.el-input__inner {
  background-position: 0rem;
  background-size: 1.6875rem 1.6875rem;
}

.wall_txt {
  width: 10.625rem;
  height: 1.75rem;
}

.ph_rbox_select {
  .tokenImg {
    width: inherit;        
  }
}

.el-select-dropdown__item {
  .tokenImg {
    width: 46px;
    height: 46px;
    margin-right: 0.8125rem; 
  }
}

// 自定义右边图标
.selsectboxBNB {
  .el-input__inner {
    background: url('../../assets/images/BNB.png') no-repeat center center;
    background-size: 1.25rem 1.25rem;
    background-position: 0.3125rem 0.3125rem;
    padding: 0 0 0 1.625rem;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
}

.selsectboxPolygon {
  .el-input__inner {
    background: url('../../assets/images/polygon.png') no-repeat center center;
    background-size: 1.25rem 1.25rem;
    background-position: 0.3125rem 0.3125rem;
    padding: 0 0 0 1.625rem;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
}

.selsectboxARB {
  .el-input__inner {
    background: url('../../assets/images/ARB.png') no-repeat center center;
    background-size: 1.25rem 1.25rem;
    background-position: 0.3125rem 0.3125rem;
    padding: 0 0 0 1.625rem;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
}

.selsectboxZKS {
  .el-input__inner {
    background: url('../../assets/images/trx.png') no-repeat center center;
    background-size: 1.25rem 1.25rem;
    background-position: 0.3125rem 0.3125rem;
    padding: 0 0 0 1.625rem;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
}

// 自定义右边图标
.selsectboxChain {
  .el-input__inner {
    background: url('../../assets/images/chain.png') no-repeat center center;
    background-size: 1.25rem 1.25rem;
    background-position: 0.3125rem 0.3125rem;
    padding: 0 0 0 1.625rem;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
}

.selsectboxEnglish {
  .el-input__inner {
    background: url('../../assets/images/English.png') no-repeat center center;
    background-size: 1.25rem 1.25rem;
    background-position: 0.3125rem 0.3125rem;
    padding: 0 0 0 1.625rem;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
}

.selsectboxрусскийязык {
  .el-input__inner {
    background: url('../../assets/images/русскийязык.png') no-repeat center center;
    background-size: 1.25rem 1.25rem;
    background-position: 0.3125rem 0.3125rem;
    padding: 0 0 0 1.625rem;
    box-sizing: border-box;
    font-size: 0.875rem;
  }
}

::v-deep .el-drawer__header {
  margin-bottom: 0;

  > :first-child {
    font-size: 1.5rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
  }
}

.drawer_title {
  margin-bottom: 56px;
  display: flex;
  align-items: center;

  span {
    margin-left: 14px;
    // margin-right: 1.45rem;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
  }
  .RDOM,.NFT,.Airdrop,.ifBank{
    margin-left: 48px;
    width: 39px;
    height: 39px;
  }
}
.drawer_titles {
  margin-bottom: 46px;
  display: flex;
  align-items: center;

  span {
    margin-left: 14px;
    // margin-right: 1.45rem;
    font-size: 29px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #999999;
  }
  .RDOM,.NFT,.Airdrop,.ifBank{
    margin-left: 48px;
    width: 39px;
    height: 39px;
  }
}
.drawer_titlesa{
  margin-top: 33px !important;
}

.sidebar_two_ch {
  height: 94%;
  overflow: auto;

  .sidebar_two_ch_one {
    display: flex;
    flex-direction: column;
    margin-left: 0.41rem;
    margin-right: 0.41rem;
    margin-top: 0.27rem;

    // > div {
    //   margin-bottom: 1.75rem;
    //   cursor: pointer;
    //   padding-left: 1.83rem;

    //   image {
    //     margin-right: 1.92rem;
    //   }

    //   .home {
    //     width: 1.25rem;
    //     height: 1.33333rem;
    //   }

    //   .RDOM {
    //     width: 1.25rem;
    //     height: 1.33333rem;
    //   }

    //   .WorldCupBlindBox {
    //     width: 1.58rem;
    //     height: 1.58rem;
    //   }

    //   .NFTSynthesisAndMining {
    //     width: 1.58rem;
    //     height: 1.42rem;
    //   }

    //   .NFT {
    //     width: 1.25rem;
    //     height: 1.25rem;
    //   }

    //   .Airdrop {
    //     width: 1.38542rem;
    //     height: 1.05133rem;
    //   }

    //   .ifBank {
    //     width: 1.25rem;
    //     height: 1.25rem;
    //   }

    //   .languageSwitch {
    //     width: 1.25rem;
    //     height: 1.25rem;
    //   }

    //   span {
    //     font-size: 1.25rem;
    //     font-family: PingFangSC-Medium, PingFang SC;
    //     font-weight: 500;
    //     color: #000;
    //     line-height: 1.25rem;
    //   }

    //   .Introductions {
    //     font-size: 1.25rem;
    //     font-family: PingFangSC-Medium, PingFang SC;
    //     font-weight: 600;
    //     color: #000;
    //     line-height: 1.25rem;
    //   }

    //   a {
    //     color: #fff;
    //     display: flex;
    //     align-items: center;
    //   }
    // }

    .pullDown {
      width: 0.19rem;
      height: 0.16rem;
    }

    
  }
}

.Download {
  padding: 0 1.0625rem 2.125rem;
  // position: absolute;
  // bottom: 0;
  height: 42%;

  .Download_title {
    font-family: PingFangSC-Semibold, PingFang SC;
    color: rgba(255, 255, 255, 1);
    font-size: 0.875rem;
    text-align: center;
  }

  .Wallets {
    color: rgba(255, 255, 255, 1);
    font-size: 25px;
    margin: 1.25rem 0;
    text-align: center;
  }

  .Wallets_img {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    padding-left:50px;
    align-items: center;
    image {
      width: 2.625rem;
      height: 2.625rem;
      margin-bottom: 1.5rem;
    }

    .Wallets_div {
      width: 2.625rem;
      height: 0;
      visibility: hidden;
    }
    .Twitter{
      width:41px;
      height:36px;
      margin-right:25px;
    } 
    .telegram{
      width:40px;
      height:34px;
      margin-right:25px;
    } 
    .Medium{
      width:47px;
      height:47px;
      margin-right:25px;
    } 
    .github{
      width:36px;
      height:39px;
    }
  }

  .Exchanges {
    color: rgba(255, 255, 255, 1);
    font-size: 0.75rem;
    text-align: center;
    margin-bottom: 1.25rem;
  }

  .Exchanges_img {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    image {
      width: 2.625rem;
      height: 2.625rem;
    }
  }
}

@media screen and (min-width: 48rem) {
  .Download {
    padding: 0 1.5rem 3rem;
    // position: absolute;
    // bottom: 0;

    .Download_title {
      font-family: PingFangSC-Semibold, PingFang SC;
      color: rgba(255, 255, 255, 1);
      font-size: 1.17rem;
      text-align: center;
    }

    .Wallets {
      color: rgba(255, 255, 255, 1);
      font-size: 25px;
      margin: 2rem 0;
      text-align: center;
    }

    .Wallets_img {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      padding-left:50px;
      align-items: center;
      image {
        width: 3.5rem;
        height: 3.5rem;
        margin-bottom: 2rem;
      }

      .Wallets_div {
        width: 3.5rem;
        height: 0;
        visibility: hidden;
      }
      .Twitter{
        width:41px;
        height:36px;
        margin-right:25px;
      } 
      .telegram{
        width:40px;
        height:34px;
        margin-right:25px;
      } 
      .Medium{
        width:47px;
        height:47px;
        margin-right:25px;
      } 
      .github{
        width:36px;
        height:39px;
      }
    }

    .Exchanges {
      color: rgba(255, 255, 255, 1);
      font-size: 1rem;
      text-align: center;
      margin-bottom: 2rem;
    }

    .Exchanges_img {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      image {
        width: 3.5rem;
        height: 3.5rem;
      }
    }
  }
}

.headers {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  animation-name: LeftToRight;
  animation-duration: 0.5s;
  background: #303234;
}

@keyframes LeftToRight {
  0% {
    background: rgba(37, 32, 108, 0);
  }
  100% {
    background: rgba(37, 32, 108, 1);
  }
}

.popper__arrow {
  display: none !important;
}

.el-popper {
  background-color: #141828 !important;
  background: #141828 !important;
  margin-top: 0.3125rem !important;
  right: 0.625rem !important;
  left: auto !important;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 0.0625rem;
  margin-left: -0.375rem;
  border-top-width: 0;
  border-bottom-color: #141828;
}
.logoLOff{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:108px 39px 45px;
  .logoL{
    width:209px;
    // margin-left:39px;
    // margin-bottom:45px;
  }
  .Off{
    width:35px;
    height:36px;
  }
}
.sidebar_two_title {
  display: flex;
  flex-direction: column;
  margin-bottom: 56px;
  .Introduction {
    cursor: pointer;
    margin-right: 0.11rem;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
  }
  .ifBank{
    margin-left: 48px;
    width: 39px;
    height: 39px;
    margin-right: 14px;
  }
}
.sidebar_two_downContent {
  margin-left:99px;
  div {
    margin-top: 16px;
    font-size: 25px;
    font-family: MicrosoftYaHei;
    color: #999999;
    cursor: pointer;
    // margin-left: 73px;
  }
}
.img26{
  width:20px;
  margin-left: 20px;
  cursor: pointer;
}
</style>